import LoadError from '../Constants/LoadError';

/**
 * Initialises an encrypyed HLS stream by setting the `src` property
 * of the provided video element to a provided HLS manifest, and
 * waiting for the resulting `onwebkitneedkey` event.
 *
 * Returns a promise which is resolved with the DRM "init data"
 * provided by the `webkitneedkey` event.
 */

const initEncryptedStream = (
    videoElement: HTMLVideoElement,
    src: string
): Promise<Uint8Array> =>
    new Promise((resolve, reject) => {
        (videoElement as any).onwebkitneedkey = e => {
            videoElement.onerror = null;

            resolve(e.initData);
        };

        videoElement.onerror = err => {
            videoElement.onerror = null;

            if (videoElement.networkState === videoElement.NETWORK_NO_SOURCE) {
                reject(new Error(LoadError.NETWORK_NO_SOURCE));
            }

            reject(err);
        };

        videoElement.src = src;
    });

export default initEncryptedStream;